import { Button, Form, Input, message, Modal } from 'antd';
import React from 'react'
import { LocalStorageService } from '../services/LocalStorage';
import AxiosService from '../services/APIService';

const CreateNoteModel = ({ setIsModalOpen, isModalOpen, setLoading }) => {
    const [form] = Form.useForm();
    const userData = LocalStorageService.getItem("user");
    const apiService = new AxiosService()

    const handleCreateNote = (values) => {
        if (!userData._id || !values.description) {
            message.error("User ID and note description are required");
            return;
        }

        const newNote = {
            userId: userData._id,
            note: values.description,
        };

        setLoading(true);

        apiService.post('/notes/create-note', newNote)
            .then((res) => {
                message.success(res.message);
                setIsModalOpen(false);
                form.resetFields();
            })
            .catch((e) => {
                message.error(e.response?.data?.error || "Something went wrong");
            })
            .finally(() => setLoading(false));
    };

    return (
        <Modal
            title="Create Note"
            open={isModalOpen}
            onCancel={() => { setIsModalOpen(false); form.resetFields(); }}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={handleCreateNote}>
                <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ required: true, message: 'Please enter Description' }]}
                >
                    <Input.TextArea autoSize={{ minRows: 4, maxRows: 6 }} placeholder="Enter your note here..." />
                </Form.Item>
                <Form.Item style={{ marginBottom: '0px' }}>
                    <Button type="primary" htmlType="submit">Save Note</Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default CreateNoteModel